export default __webpack_public_path__ + "static/media/art5.82466393.jpg";